import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, ɵConsole } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppState } from '../../../../app.reducer';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, take, takeUntil, distinctUntilChanged } from "rxjs/operators";
import { GetInbox, GetMailById, MarkMailAsRead, DeleteMail, GetAllCmpMeassagesStart, GetMailByIdInAllCmpStart, GetSearchedMail, GetSearchedAllMails, DeleteMessage, SendContentToMail } from "../_store/messages.actions";
import { ComposeMessageComponent } from '../compose-message/compose-message.component';
import { TagMessagesDialogComponent } from '../../../../dialogs/tag-messages-dialog/tag-messages-dialog.component';
import * as moment from 'moment-mini-ts'
import { Router, Route, ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

import { newMessageTagService } from '../../../../services/messageTags.service'
import { NotificationModalComponent } from 'src/app/features/common-components/notification-modal/notification-modal.component';
import { LoaderShow, LoaderHide } from 'src/app/features/loader/store/loader.actions';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'inbox',
    templateUrl: './inbox.component.html',
    styleUrls: ['./inbox.component.scss']
})
export class InboxComponent implements OnInit, OnDestroy {
    inboxEmails$;
    inboxSearchedEmails;
    mailType: string = 'inbox';
    selectedThreadId: string;
    emailDetail: any = {};
    private stopper: Subject<void> = new Subject<void>();
    currentUser;
    index = 0;
    @ViewChild('inboxDiv', { static: false }) inboxDiv: ElementRef;
    myMessages: boolean = true;
    allCmpMessagesPageNumber: number = 1;
    allCmpMessagesPages: number = 0;
    myMessagesPageNumber: number = 1;
    myMessagesPages: number = 0;
    // added child elemt of div
    allCmpMessages: boolean = false;
    replacedUsersMessages: boolean = false;
    inboxSearchedAllEmails

    searchInput = new FormControl();
    searchResults$;
    showSearchResults: boolean = false;
    inboxList: any = [];
    searchForBothTabs: boolean = false;
    searchString: string = '';
    selectedMessageIndex: number = 0;

    replacedUsersId: string;
    currentUserName;
    ifSearched: boolean = false;
    host = environment.host;

    inputSearchTypeDate = true;
    inputSearchTypeText = false;

    searchOption: string = 'date'

    constructor(
        private store: Store<AppState>,
        private dialog: MatDialog,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private tagService: newMessageTagService
    ) {
        this.store.select(state => state.auth.user).subscribe((userDetails: any) => {
            return this.currentUser = userDetails
        });

        this.currentUserName = this.currentUser.details.firstName + ' ' + this.currentUser.details.lastName;

        this.store.select(state => state.messages.searchMailResults).pipe(takeUntil(this.stopper)).subscribe(
            res => {
                this.store.dispatch(new LoaderHide())

                this.myMessagesPageNumber = res.searchedDetails.page
                this.myMessagesPages = res.searchedDetails.pages;
                if (res && Object.keys(res).length) {
                    // this.showSearchResults =true;

                    console.log(this.currentUser);



                    this.inboxSearchedEmails = res.docs.map((mail: any) => {
                        let recentMessage = mail.message ? mail.message[0] : mail;
                        // let fromMessage = recentMessage.from || {};
                        // const fromDisplayName = ((fromMessage || {})._id === this.currentUser.details._id) ?  this.currentUserName :
                        // ((recentMessage.from).firstName) ? `${fromMessage.firstName} ${fromMessage.middleName || ''} ${fromMessage.lastName || ''}` : `${fromMessage.firstName || ''} ${fromMessage.middleName || ''} ${fromMessage.lastName || ''}`;
                        return {
                            ...mail,
                            ...recentMessage,
                            read: !this.replacedUsersMessages ? recentMessage.read : true // all messages will be set to read for replaced users inbox
                        }
                    })

                    console.log("this.inboxSearchedEmails", this.inboxSearchedEmails)
                }
                else {
                    this.inboxSearchedEmails = []
                }
            }
        );

        this.store.select(state => state.messages.searchAllMailResults).subscribe(
            res => {
                this.store.dispatch(new LoaderHide())

                this.allCmpMessagesPageNumber = res.searchedAllMailDetails.page
                this.allCmpMessagesPages = res.searchedAllMailDetails.pages;
                // this.my
                if (res && Object.keys(res).length) {

                    this.inboxSearchedAllEmails = res.docs.map((mail: any) => {

                        let recentMessage = mail.message ? mail.message[0] : mail;
                        // let fromMessage = recentMessage.from || {};
                        // const fromDisplayName = ((fromMessage || {})._id === this.currentUser.details._id) ?  this.currentUserName :
                        //     ((recentMessage.from).firstName) ? `${fromMessage.firstName} ${fromMessage.middleName || ''} ${fromMessage.lastName || ''}` : `${fromMessage.firstName || ''} ${fromMessage.middleName || ''} ${fromMessage.lastName || ''}`;
                        return {
                            ...mail,
                            ...recentMessage,
                            createdAt: new Date(mail.createdAt),
                            read: recentMessage.read,
                        }
                    })
                    console.log(this.inboxSearchedAllEmails);
                }
            }
        )
    }

    ngOnInit() {
        this.searchInput.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((searchString) => {

            if (this.inputSearchTypeText && searchString.toString().length > 0) {
                this.searchString = new Date(searchString.getFullYear(), searchString.getMonth(), searchString.getDate() + 1, 0, 0, 0).toISOString()
            }
            else
                this.searchString = searchString;
            this.ifSearched = true;
            console.log(this.allCmpMessages);
            if (this.myMessages) {
                if (this.searchString === '') {
                    this.ifSearched = false;
                    this.store.dispatch(new GetInbox({ 'page': 1, "limit": 10 }))
                } else {

                    if (this.inputSearchTypeText) {
                        this.store.dispatch(new GetInbox({ searchDate: this.searchString, 'page': 1, 'limit': 10 }))
                    }
                    else {
                        this.store.dispatch(new GetSearchedMail({ search: this.searchString, 'page': 1, 'limit': 10 }))
                    }

                }

            } else if (this.allCmpMessages) {
                if (this.searchString === '') {
                    this.ifSearched = false;
                    this.store.dispatch(new GetAllCmpMeassagesStart({ 'page': 1, 'limit': 10 }));
                } else {
                    if (this.inputSearchTypeText) {
                        this.store.dispatch(new GetAllCmpMeassagesStart({ searchDate: this.searchString, 'page': 1, 'limit': 10 }));
                    }
                    else {
                        this.store.dispatch(new GetSearchedAllMails({ search: this.searchString, 'page': 1, 'limit': 10 }));

                    }
                }
            } else {
                if (this.searchString === '') {
                    this.ifSearched = false;
                    this.store.dispatch(new GetInbox({ 'page': 1, 'limit': 10, 'aliasId': this.replacedUsersId }));
                }
                else if (this.inputSearchTypeText) {
                    this.store.dispatch(new GetInbox({ searchDate: this.searchString, 'page': 1, 'limit': 10, 'aliasId': this.replacedUsersId }));
                }
                else {
                    this.store.dispatch(new GetSearchedMail({ search: this.searchString, 'page': 1, 'limit': 10, 'aliasId': this.replacedUsersId }));
                }
            }

        });
        let endPoint = this.activatedRoute.snapshot.routeConfig.path;
        if (endPoint === 'my-messages') {
            this.myMessages = true;
            this.allCmpMessages = false;
            this.replacedUsersMessages = false;
            if (!this.ifSearched) {
                this.store.dispatch(new GetInbox({ 'page': 1, "limit": 10 }))
            }
            else {
                this.store.dispatch(new GetSearchedMail({ search: '', 'page': 1, 'limit': 10 }))
            }
        } else if (endPoint === "all-cmp-messages") {
            this.allCmpMessages = true;
            this.myMessages = false;
            this.replacedUsersMessages = false;
            if (!this.ifSearched) {
                this.store.dispatch(new GetAllCmpMeassagesStart({ 'page': 1, 'limit': 10 }));
            } else {
                this.store.dispatch(new GetSearchedAllMails({ search: '', 'page': 1, 'limit': 10 }))
            }
        } else {
            this.replacedUsersMessages = true;
            this.myMessages = false;
            this.allCmpMessages = false;

            this.activatedRoute.params.subscribe(params => {
                this.selectedThreadId = "";
                this.replacedUsersId = params.userId;
                if (!this.ifSearched) {
                    this.store.dispatch(new GetInbox({ 'page': 1, "limit": 10, 'aliasId': this.replacedUsersId }));
                }
                else {
                    if (this.inputSearchTypeText) {
                        this.store.dispatch(new GetInbox({ searchDate: this.searchString, 'page': 1, "limit": 10, 'aliasId': this.replacedUsersId }));
                    }
                    else
                        this.store.dispatch(new GetSearchedMail({ search: '', 'page': 1, 'limit': 10, 'aliasId': this.replacedUsersId }));
                }
            })

        }
        this.store.select(state => state.messages.inbox).pipe(takeUntil(this.stopper),
            map((list: any) => {
                // this.inboxList = list;
                if (this.inboxDiv) {
                    // console.log(this.inboxDiv.nativeElement.scrollHeight, "element");
                    // console.log(this.inboxDiv.nativeElement.scrollTop )
                    // this.inboxDiv.nativeElement.scrollTop= this.inboxDiv.nativeElement.scrollHeight;
                }
                if (this.myMessages || this.replacedUsersMessages) {
                    if (list && list.details) {
                        this.myMessagesPageNumber = list.details.page;
                        this.myMessagesPages = list.details.pages;
                    }
                } else {
                    if (list && list.details) {
                        this.allCmpMessagesPageNumber = list.details.page;
                        this.allCmpMessagesPages = list.details.pages;
                    }
                }
                return list.docs.map((mail: any) => {
                    // console.log(mail, "mail")
                    //if(index == 0) this.selectedThreadId = mail.threadId;
                    /* let readStatus = true;
                    const fromDisplayName = mail.messages.map(message => {
                      return (message.from.name) ? message.from.name : `${message.from.firstName} ${message.from.secondName}`;
                    }).join(", ");
                    mail.messages.forEach(message => {
                      if(message.read === false) {
                        readStatus = message.read;
                        return;
                      }
                    }) */
                    let recentMessage = mail.messages ? mail.messages[mail.messages.length - 1] : mail;
                    // console.log(recentMessage, "message");
                    let fromMessage = recentMessage.from || {};
                    const fromDisplayName = ((fromMessage || {})._id === this.currentUser.details._id) ? this.currentUserName :
                        ((recentMessage.from).firstName) ? `${fromMessage.firstName} ${fromMessage.middleName || ''} ${fromMessage.lastName || ''}` : `${fromMessage.firstName || ''} ${fromMessage.middleName || ''} ${fromMessage.lastName || ''}`;
                    return {
                        ...mail,
                        createdAt: new Date(mail.createdAt),
                        fromDisplayName: fromDisplayName,
                        read: !this.replacedUsersMessages ? recentMessage.read : true // all messages will be set to read for replaced users inbox
                    }
                })
            })
        ).subscribe(results => {
            this.inboxEmails$ = results;
        });
        this.store.select(state => state.messages.messageDetail).pipe(takeUntil(this.stopper)).subscribe((detail: any) => {
            if ((detail || {}).messages) {
                if (this.myMessages) {
                    if (!this.ifSearched) {
                        this.store.select(state => state.messages.messageCount).subscribe(response => {
                            if (Object.keys(response).length) {
                                this.inboxEmails$.map(thread => {
                                    if (thread.threadId == response.thread) {
                                        if (thread.messages.length > 0) {
                                            thread.messages.map(message => {
                                                if (message._id == response.message) {
                                                    let index = thread.messages.indexOf(message);
                                                    thread.messages.splice(index, 1);
                                                }
                                            })
                                        }
                                    }

                                })
                            }
                        })
                    }
                    else {
                        this.store.select(state => state.messages.messageCount).subscribe(response => {
                            if (Object.keys(response).length) {
                                this.inboxSearchedEmails.map(thread => {
                                    if (thread.threadId == response.thread) {
                                        if (thread.message.length > 0) {
                                            thread.message.map(message => {
                                                if (message.id == response.message) {
                                                    let index = thread.message.indexOf(message);
                                                    thread.message.splice(index, 1);
                                                }
                                            })
                                        }
                                    }

                                })
                            }
                        })
                    }
                }
                this.store.dispatch(new LoaderHide())

                detail.messages.map((message: any) => {
                    const toDisplayName = message.to.map(user => {
                        if (user.type === 'user') {
                            return (user._id === this.currentUser.details._id) ?
                                this.currentUserName :
                                (user.firstName) ? `${user.firstName} ${user.middleName || ''} ${user.lastName || ''} ` : `${user.firstName || ''} ${user.middleName || ''} ${user.lastName || ''}`;
                        }
                        else if (user.type === 'group') {
                            return (user._id === this.currentUser.details._id) ?
                                this.currentUserName : (user.name) ? `${user.name} (${user.type})` : `${('Group')}`
                        }
                        else {
                            return (user._id === this.currentUser.details._id) ?
                                this.currentUserName : (user.firstName) ? `${user.firstName} ${user.middleName || ''} ${user.lastName || ''} ` : `${user.firstName || ''} ${user.middleName || ''} ${user.lastName || ''}`;

                        }
                    }).join(", ");
                    let fromMessage = message.from || {};
                    message.fromDisplayName = ((fromMessage || {})._id === this.currentUser.details._id) ? this.currentUserName :
                        ((message.from).firstName) ? `${fromMessage.firstName} ${fromMessage.middleName || ''} ${fromMessage.lastName || ''}` : `${fromMessage.firstName || ''} ${fromMessage.middleName || ''} ${fromMessage.lastName || ''}`;

                    message.toDisplayName = toDisplayName;
                    message.displayPic = `${environment.host}/user/getImage/${message.from._id}`

                });
                this.emailDetail = detail;
                console.log("EmailDetail", this.emailDetail);
                if (detail.messages.length) {
                    if (!detail.messages[detail.messages.length - 1].read) {
                        if (this.myMessages) {
                            // to fix error: go to replaced users inbox →  open any mail → go back to my messages tab, selectedThreadId is undefined in this case
                            if (this.selectedThreadId) {
                                return this.store.dispatch(new MarkMailAsRead(this.selectedThreadId, this.myMessages));
                            }
                        }
                        // need to implement after all  high priority issues completed
                        // else {
                        // detail.messages.some((message) => )
                        // }
                    }
                }
            }
        });
        this.store.select(state => state.auth).subscribe(auth => {
            let capabilities = auth.user.capabilities;
            let index = capabilities.findIndex((capability) => capability === 'view-all-cmp-messages');
            if (index !== -1) {
                this.searchForBothTabs = true;
            }
            else {
                this.searchForBothTabs = false
            }
        });
        this.store.select(state => state.messages.markMailAsReadSuccess).subscribe(resp => {
            if (resp.message) {
                if (this.myMessages && this.ifSearched) {
                    if (this.inboxSearchedEmails.length) {
                        (this.inboxSearchedEmails[this.selectedMessageIndex] || {}).read = true;
                    }
                } else {
                    if (this.inboxEmails$[this.selectedMessageIndex]) {
                        this.inboxEmails$[this.selectedMessageIndex].read = true;
                    }
                }

            }
        });
    }

    getMailDetails(threadId: string, index: number) {
        this.store.dispatch(new LoaderShow());

        this.selectedMessageIndex = index;
        this.selectedThreadId = threadId;

        if (this.myMessages) {
            this.store.dispatch(new MarkMailAsRead(this.selectedThreadId, this.myMessages));
            this.store.dispatch(new GetMailById(this.selectedThreadId));
        }
        else if (this.replacedUsersMessages) {
            this.store.dispatch(new GetMailById(this.selectedThreadId, this.replacedUsersId));
        }
        else {
            return;
        }
    }

    launchMessage(messageType: string, msgIndex: number = -1, messageInfo: any = {}, tags?: any) {
        if (tags) {
            this.tagService.newTagsList(tags)
        }
        const dialogRef = this.dialog.open(ComposeMessageComponent, {
            width: '50%',
            panelClass: 'cmp-modal',
            data: {
                type: messageType,
                index: msgIndex,
                info: messageInfo,
            },
            autoFocus: false

        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (this.selectedThreadId) {
                    this.store.dispatch(new GetMailById(this.selectedThreadId));
                }
            }
        });
    }

    deleteMailThread(threadId) {
        this.store.dispatch(new DeleteMail(threadId));
        this.resetSelection();
    }

    resetSelection() {
        this.emailDetail = {};
        this.selectedThreadId = '';
    }

    // tabChange(event) {
    //     if (this.showSearchResults) return;
    //     this.myMessagesPageNumber = 1;
    //     this.myMessagesPages = 0;
    //     this.allCmpMessagesPageNumber = 1;
    //     this.allCmpMessagesPages = 0;
    //     switch (event.index) {
    //         case 0:
    //             this.myMessages = true;
    //             this.store.dispatch(new GetInbox({ 'page': this.myMessagesPageNumber, 'limit': 10 }))
    //             break;
    //         case 1:
    //             this.myMessages = false;
    //             this.store.dispatch(new GetAllCmpMeassagesStart({ 'page': this.allCmpMessagesPageNumber, 'limit': 10 }));
    //             break;
    //     }
    //     this.resetSelection();
    // }

    onScroll(event) {
        const tableViewHeight = event.target.offsetHeight; // viewport: ~500px
        const tableScrollHeight = event.target.scrollHeight; // length of all table
        const scrollLocation = event.target.scrollTop; // how far user scrolled
        const buffer = 0;
        const limit = tableScrollHeight - tableViewHeight - buffer;
        if (scrollLocation >= limit) {
            if (this.myMessages || this.replacedUsersMessages) {
                if (this.myMessagesPageNumber < this.myMessagesPages) {
                    this.myMessagesPageNumber++;

                    if (this.ifSearched) {
                        if (this.inputSearchTypeText) {
                            this.store.dispatch(new GetInbox({ searchDate: this.searchString, 'page': this.myMessagesPageNumber, 'limit': 10 }))
                        }
                        else {
                            this.store.dispatch(new GetSearchedMail({ search: this.searchString, 'page': this.myMessagesPageNumber, 'limit': 10 }))
                        }
                    }
                    else {
                        if (this.replacedUsersId) {
                            this.store.dispatch(new GetInbox({ 'page': this.myMessagesPageNumber, 'limit': 10, aliasId: this.replacedUsersId }))
                        }
                        else {
                            this.store.dispatch(new GetInbox({ 'page': this.myMessagesPageNumber, 'limit': 10 }))
                        }
                    }
                }
            } else {

                if (this.allCmpMessagesPageNumber < this.allCmpMessagesPages) {
                    this.allCmpMessagesPageNumber++;
                    if (this.ifSearched) {
                        if (this.inputSearchTypeText) {
                            this.store.dispatch(new GetAllCmpMeassagesStart({ searchDate: this.searchString, 'page': this.myMessagesPageNumber, 'limit': 10 }))
                        }
                        else
                            this.store.dispatch(new GetSearchedAllMails({ search: this.searchString, 'page': this.allCmpMessagesPageNumber, 'limit': 10 }));
                    }
                    else {
                        this.store.dispatch(new GetAllCmpMeassagesStart({ 'page': this.allCmpMessagesPageNumber, 'limit': 10 }))
                    }
                }
            }
        }
    }

    onDocClick(document) {

        if (!document.isDeleted) {
            this.router.navigate([`../home/resources/doc/${document._id || document.id}`])
        }

    }

    getMailDetailsForAllCmp(id) {
        this.selectedThreadId = id;
        this.store.dispatch(new GetMailByIdInAllCmpStart(id));

    }



    addMessageTags(message: any = {}) {
        const dialog = this.dialog.open(TagMessagesDialogComponent, {
            width: "40%",
            hasBackdrop: true,
            panelClass: "task-detail-modal",
            data: {
                allDetails: message,
                type: "messageTags",
                alertTitle: "Add tag to message",
                placeHolder: "Add Tag (search with key words)"
            }
        });
    }


    ngOnDestroy() {
        this.stopper.next();
        this.stopper.complete();
    }

    DeleteMessage(messageId, threadId, message) {
        console.log(message.length);
        const dialogRef = this.dialog.open(NotificationModalComponent, {
            width: "40%",
            panelClass: 'cmp-modal',
            data: {
                text: "Are you sure you want to delete this message?"
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (this.emailDetail.messages.length < 2) {
                    this.selectedThreadId = ""
                }
                console.log(message.length);
                this.store.dispatch(new DeleteMessage(messageId, threadId, message.length));
                // if (message.length == 1) {
                //     // this.store.dispatch(new GetInbox({ 'page': 1, 'limit': 10 }));
                //     this.store.dispatch(new GetSearchedMail({ search: '', 'page': 1, 'limit': 10 }))
                // }
            }
        });
    }

    /* 
      @author Pooja Gawas
      Send message content to logged in users registered email
    */
    sendContentToMail(parentId) {
        const dialogRef = this.dialog.open(NotificationModalComponent, {
            width: "40%",
            panelClass: 'cmp-modal',
            data: {
                text: "Are you sure you want to email the contents of this message?"
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.store.dispatch(new SendContentToMail(parentId));
            }
        });
    }

    setDefaultPic(item) {
        item.displayPic = "assets/images/user_profile.svg";
    }


    messageSearchInput(input) {
        this.searchInput.setValue('')

        this.inputSearchTypeDate = input === 'date' ? true : false;
        this.inputSearchTypeText = input === 'text' ? true : false;

    }

    clearInputField() {
        this.searchInput.setValue('')
    }

    refreshUsers(value) {
        if (value == 'mymessages' && this.replacedUsersId) {
            this.store.dispatch(new GetInbox({ 'page': 1, "limit": 10, "aliasId": this.replacedUsersId }))
        }
        else if (value == 'mymessages') {
            this.store.dispatch(new GetInbox({ "page": 1, "limit": 10 }))
        }
        else {
            this.store.dispatch(new GetAllCmpMeassagesStart({ 'page': 1, 'limit': 10 }))
        }
    }

    convertUTCDateToLocalDate(date) {
        if (date) {
            return new Date(date)
        }
    }

}
